<template>
    <div class="Paysuc">
        <header>
            <img class="h-icon" src="../assets/images/paysuc-icon.png" width="75" height="75">
            <div class="h-tips">
                支付成功
            </div>
        </header>
        <div class="card">
            <div class="price">{{orderinfo.money}}</div>
            <hr>
            <div style="margin-top:15px;">
            <div style="display:flex;margin:10px 0;letter-spacing: 1px;"><div style="width:20%;text-align:right;color:#666;">案件号</div><div style="width:75%;margin-left:5%;color:#000;">{{orderinfo.caseid}}</div></div>
            <div style="display:flex;margin:10px 0;letter-spacing: 1px;"><div style="width:20%;text-align:right;color:#666;">商户单号</div><div style="width:75%;margin-left:5%;color:#000;">{{orderinfo.outTradeNo}}</div></div>
            <div style="display:flex;margin:10px 0;letter-spacing: 1px;"><div style="width:20%;text-align:right;color:#666;">支付方式</div><div style="width:75%;margin-left:5%;color:#000;">微信支付</div></div>
            <div style="display:flex;margin:10px 0;letter-spacing: 1px;"><div style="width:20%;text-align:right;color:#666;">温馨提示</div><div style="width:75%;margin-left:5%;color:#000;">本案件已成功受理，翻译完成后我处将会以短信或电话方式通知您，请耐心等待</div></div>
        </div>
        </div>
        <footer style="margin:60px 0;">
<mt-button style="width:100%;background-color:#1E70E0;color:white;" @click.native="toDetail">返回</mt-button>
    </footer>
    </div>
</template>

<script>
export default {
    name:"Paysuc",
    data(){
        return{
            orderinfo:""
        }
    },
    created(){
        this.orderinfo = this.$route.query;
    },
    methods:{
        toDetail(){
            this.$router.push("/Detail.html?caseguid="+this.orderinfo.caseguid);
        }
    }
}
</script>

<style scoped>
header{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 200px;
    background-color: #1E70E0;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
    padding: 0 15px;
    padding-bottom: 20%;
    box-sizing: border-box;
}
.h-tips{font-size: 20px;margin-top: 20px;}
.h-icon{justify-self: self-end;}
.card{
    position: relative;
    z-index: 2;
    background-color: white;
    border-radius: 10px;
    margin-top: 120px;
    box-shadow: 0 3px 6px rgba(0,0,0,.1);
    padding: 15px;
    box-sizing: border-box;
    text-align: left;
    line-height: 1.5;
    font-size: 13px;
}
.card .price{
    width: 100%;
    padding: 15px 0;
    text-align: center;
    color:#E61919;
    font-size: 24px;
    font-weight: bold;
}
.card p{color:#222222;font-size: 13px;}
.card span{
    color: #3E3E3E;
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Paysuc.vue